import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { METHODS, SERVICES } from '../../api/constants';
import { makeRequest } from '../../api/api';
import CryptoJS from 'crypto-js';

export const fetchRank = createAsyncThunk(
  'progressSlice/fetchRank',
  async (param, thunkApi) => {
    try {
      const hash = CryptoJS.HmacSHA256(
        JSON.stringify(param),
        '2d1e1v2e4s3h8zkkhehkod2d02fhjewjbd2whj4'
      ).toString(CryptoJS.enc.Hex);

      const response = await makeRequest(
        SERVICES.SPRINGBOOT_TO_NODE_APIS,
        '/progress/ranks',
        METHODS.POST,
        {},
        { ...param },
        [
          { key: 'access-key', value: 'sxb0zhsqm8yjpttc79iqlizxyd3e1a2' },
          { key: 'signature', value: hash }
        ]
      );

      return response?.data;
    } catch (e) {
      return thunkApi.rejectWithValue(e);
    }
  }
);

export const fetchAttendanceStats = createAsyncThunk(
  'progressSlice/fetchAttendanceStats',
  async (param, thunkApi) => {
    try {
      const hash = CryptoJS.HmacSHA256(
        JSON.stringify(param),
        '2d1e1v2e4s3h8zkkhehkod2d02fhjewjbd2whj4'
      ).toString(CryptoJS.enc.Hex);

      const response = await makeRequest(
        SERVICES.SPRINGBOOT_TO_NODE_APIS,
        '/progress/overall',
        METHODS.POST,
        {},
        { ...param },
        [
          { key: 'access-key', value: 'sxb0zhsqm8yjpttc79iqlizxyd3e1a2' },
          { key: 'signature', value: hash }
        ]
      );

      return response?.data;
    } catch (e) {
      return thunkApi.rejectWithValue(e);
    }
  }
);

export const fetchLearningAttendanceDetails = createAsyncThunk(
  'progressSlice/fetchLearningAttendanceDetails',
  async (param, thunkApi) => {
    try {
      const hash = CryptoJS.HmacSHA256(
        JSON.stringify(param),
        '2d1e1v2e4s3h8zkkhehkod2d02fhjewjbd2whj4'
      ).toString(CryptoJS.enc.Hex);

      const response = await makeRequest(
        SERVICES.SPRINGBOOT_TO_NODE_APIS,
        '/progress/attendance-details',
        METHODS.POST,
        {},
        { ...param },
        [
          { key: 'access-key', value: 'sxb0zhsqm8yjpttc79iqlizxyd3e1a2' },
          { key: 'signature', value: hash }
        ]
      );

      return response?.data;
    } catch (e) {
      return thunkApi.rejectWithValue(e);
    }
  }
);

export const fetchGradeDetails = createAsyncThunk(
  'progressSlice/fetchGradeDetails',
  async (param, thunkApi) => {
    try {
      const hash = CryptoJS.HmacSHA256(
        JSON.stringify(param),
        '2d1e1v2e4s3h8zkkhehkod2d02fhjewjbd2whj4'
      ).toString(CryptoJS.enc.Hex);

      const response = await makeRequest(
        SERVICES.SPRINGBOOT_TO_NODE_APIS,
        '/progress/activity-details',
        METHODS.POST,
        {},
        { ...param },
        [
          { key: 'access-key', value: 'sxb0zhsqm8yjpttc79iqlizxyd3e1a2' },
          { key: 'signature', value: hash }
        ]
      );

      return response?.data;
    } catch (e) {
      return thunkApi.rejectWithValue(e);
    }
  }
);

export const fetchMockInterviewDetails = createAsyncThunk(
  'progressSlice/fetchMockInterviewDetails',
  async (param, thunkApi) => {
    try {
      const hash = CryptoJS.HmacSHA256(
        JSON.stringify(param),
        '2d1e1v2e4s3h8zkkhehkod2d02fhjewjbd2whj4'
      ).toString(CryptoJS.enc.Hex);

      const response = await makeRequest(
        SERVICES.SPRINGBOOT_TO_NODE_APIS,
        '/progress/career-details',
        METHODS.POST,
        {},
        { ...param },
        [
          { key: 'access-key', value: 'sxb0zhsqm8yjpttc79iqlizxyd3e1a2' },
          { key: 'signature', value: hash }
        ]
      );

      return response?.data;
    } catch (e) {
      return thunkApi.rejectWithValue(e);
    }
  }
);

export const fetchSkillTestDetails = createAsyncThunk(
  'progressSlice/fetchSkillTestDetails',
  async (param, thunkApi) => {
    try {
      const hash = CryptoJS.HmacSHA256(
        JSON.stringify(param),
        '2d1e1v2e4s3h8zkkhehkod2d02fhjewjbd2whj4'
      ).toString(CryptoJS.enc.Hex);

      const response = await makeRequest(
        SERVICES.SPRINGBOOT_TO_NODE_APIS,
        '/progress/skill-test',
        METHODS.POST,
        {},
        { ...param },
        [
          { key: 'access-key', value: 'sxb0zhsqm8yjpttc79iqlizxyd3e1a2' },
          { key: 'signature', value: hash }
        ]
      );

      return response?.data;
    } catch (e) {
      return thunkApi.rejectWithValue(e);
    }
  }
);

export const fetchSkillTestAvilability = createAsyncThunk(
  'progressSlice/fetchSkillTestAvilability',
  async (param, thunkApi) => {
    try {
      const hash = CryptoJS.HmacSHA256(
        JSON.stringify(param),
        '2d1e1v2e4s3h8zkkhehkod2d02fhjewjbd2whj4'
      ).toString(CryptoJS.enc.Hex);

      const response = await makeRequest(
        SERVICES.SPRINGBOOT_TO_NODE_APIS,
        '/progress/skill-test-availability',
        METHODS.POST,
        {},
        { ...param },
        [
          { key: 'access-key', value: 'sxb0zhsqm8yjpttc79iqlizxyd3e1a2' },
          { key: 'signature', value: hash }
        ]
      );

      return response?.data;
    } catch (e) {
      return thunkApi.rejectWithValue(e);
    }
  }
);

const progressSlice = createSlice({
  name: 'progressSlice',
  initialState: {
    fetchRank: {
      isRankLoading: false,
      rankData: {},
      error: ''
    },
    fetchAttendanceStats: {
      isAttendanceStatsLoading: false,
      attendanceStatsData: {},
      error: ''
    },
    fetchLearningAttendanceDetails: {
      isLearningAttendanceDetailsLoading: false,
      learningAttendanceDetailsData: [],
      error: ''
    },
    fetchGradeDetails: {
      isLoadingGradeDetails: false,
      gradeDetailsData: {},
      error: ''
    },
    fetchMockInterviewDetails: {
      isMockInterviewDetailsLoading: false,
      mockInterviewDetailsData: [],
      error: ''
    },
    fetchSkillTestDetails: {
      isSkillTestLoading: false,
      skillTestDetailsData: [],
      error: ''
    },
    fetchSkillTestAvilability: {
      isSkillTestAvilabilityLoading: false,
      skillTestAvilabilityData: {},
      error: ''
    }
  },
  reducers: {
    resetProgressState: (state) => {
      return {
        fetchRank: {
          isRankLoading: false,
          rankData: {},
          error: ''
        },
        fetchAttendanceStats: {
          isAttendanceStatsLoading: false,
          attendanceStatsData: {},
          error: ''
        },
        fetchLearningAttendanceDetails: {
          isLearningAttendanceDetailsLoading: false,
          learningAttendanceDetailsData: [],
          error: ''
        },
        fetchGradeDetails: {
          isLoadingGradeDetails: false,
          gradeDetailsData: [],
          error: ''
        },
        fetchMockInterviewDetails: {
          isMockInterviewDetailsLoading: false,
          mockInterviewDetmockInterviewDetailsDataailsData: [],
          error: ''
        },
        fetchSkillTestDetails: {
          isSkillTestLoading: false,
          skillTestDetailsData: [],
          error: ''
        },
        fetchSkillTestAvilability: {
          isSkillTestAvilabilityLoading: false,
          skillTestAvilabilityData: {},
          error: ''
        }
      };
    }
  },
  extraReducers: (builder) => {
    builder.addCase(fetchRank.pending, (state) => {
      state.fetchRank.isRankLoading = true;
    });
    builder.addCase(fetchRank.fulfilled, (state, action) => {
      state.fetchRank.isRankLoading = false;
      state.fetchRank.rankData = action?.payload?.data || {};
    });
    builder.addCase(fetchRank.rejected, (state) => {
      state.fetchRank.isRankLoading = false;
    });
    ///////////////////////////////////////////////////////////////
    builder.addCase(fetchAttendanceStats.pending, (state) => {
      state.fetchAttendanceStats.isAttendanceStatsLoading = true;
    });
    builder.addCase(fetchAttendanceStats.fulfilled, (state, action) => {
      state.fetchAttendanceStats.isAttendanceStatsLoading = false;
      state.fetchAttendanceStats.attendanceStatsData =
        action?.payload?.data || {};
    });
    builder.addCase(fetchAttendanceStats.rejected, (state) => {
      state.fetchAttendanceStats.isAttendanceStatsLoading = false;
    });
    ///////////////////////////////////////////////////////////////
    builder.addCase(fetchLearningAttendanceDetails.pending, (state) => {
      state.fetchLearningAttendanceDetails.isLearningAttendanceDetailsLoading = true;
    });
    builder.addCase(
      fetchLearningAttendanceDetails.fulfilled,
      (state, action) => {
        state.fetchLearningAttendanceDetails.isLearningAttendanceDetailsLoading = false;
        state.fetchLearningAttendanceDetails.learningAttendanceDetailsData =
          action?.payload?.data || [];
      }
    );
    builder.addCase(fetchLearningAttendanceDetails.rejected, (state) => {
      state.fetchLearningAttendanceDetails.isLearningAttendanceDetailsLoading = false;
    });
    ///////////////////////////////////////////////////////////////
    builder.addCase(fetchGradeDetails.pending, (state) => {
      state.fetchGradeDetails.isLoadingGradeDetails = true;
    });
    builder.addCase(fetchGradeDetails.fulfilled, (state, action) => {
      console.log('Payload received in fulfilled:', action.payload);
      state.fetchGradeDetails.isLoadingGradeDetails = false;
      state.fetchGradeDetails.gradeDetailsData = action?.payload?.data || {};
    });
    builder.addCase(fetchGradeDetails.rejected, (state) => {
      state.fetchGradeDetails.isLoadingGradeDetails = false;
    });
    ///////////////////////////////////////////////////////////////
    builder.addCase(fetchMockInterviewDetails.pending, (state) => {
      state.fetchMockInterviewDetails.isMockInterviewDetailsLoading = true;
    });
    builder.addCase(fetchMockInterviewDetails.fulfilled, (state, action) => {
      state.fetchMockInterviewDetails.isMockInterviewDetailsLoading = false;
      state.fetchMockInterviewDetails.mockInterviewDetailsData =
        action?.payload?.data || [];
    });
    builder.addCase(fetchMockInterviewDetails.rejected, (state) => {
      state.fetchMockInterviewDetails.isMockInterviewDetailsLoading = false;
    });
    ///////////////////////////////////////////////////////////////
    builder.addCase(fetchSkillTestDetails.pending, (state) => {
      state.fetchSkillTestDetails.isSkillTestLoading = true;
    });
    builder.addCase(fetchSkillTestDetails.fulfilled, (state, action) => {
      state.fetchSkillTestDetails.isSkillTestLoading = false;
      state.fetchSkillTestDetails.skillTestDetailsData =
        action?.payload?.data || [];
    });
    builder.addCase(fetchSkillTestDetails.rejected, (state) => {
      state.fetchSkillTestDetails.isSkillTestLoading = false;
    });
    ///////////////////////////////////////////////////////////////
    builder.addCase(fetchSkillTestAvilability.pending, (state) => {
      state.fetchSkillTestAvilability.isSkillTestAvilabilityLoading = true;
    });
    builder.addCase(fetchSkillTestAvilability.fulfilled, (state, action) => {
      state.fetchSkillTestAvilability.isSkillTestAvilabilityLoading = false;
      state.fetchSkillTestAvilability.skillTestAvilabilityData =
        action?.payload?.data || {};
    });
    builder.addCase(fetchSkillTestAvilability.rejected, (state) => {
      state.fetchSkillTestAvilability.isSkillTestAvilabilityLoading = false;
    });
  }
});

export const { resetProgressState } = progressSlice.actions;

export default progressSlice.reducer;
